module.exports = __webpack_public_path__ + "static/media/french_quarter_kitchen_2.9dfc5b34.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/french_quarter_kitchen_2.JPG
// module id = 248
// module chunks = 0